const LOCALSTORAGE_KEYS = {
  COMPARE: 'tac-hsiyc:compare',
};

export default LOCALSTORAGE_KEYS;
